import React from 'react';
import { VARIANT_URGENCY_QUANTITY_CRITERIA } from './constants';

//@ts-check
//scoped only to variants, no matter the source - eg think quickwview plp or PDP or from another page source, uniformity... only need the variants data and quantity really...
type IUrgencyMessage = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
  quantityLeft: number | undefined | null;
  threshold?: number;
  prependHyphen?: boolean;
};

export const UrgencyMessage = ({
  className = '',
  style = { color: 'var(--alert-medium)' },
  quantityLeft,
  threshold = VARIANT_URGENCY_QUANTITY_CRITERIA,
  prependHyphen = false,
}: IUrgencyMessage): JSX.Element | null => {
  if (!quantityLeft && quantityLeft !== 0) return null;
  const hyphen = prependHyphen ? <span>{' - '}</span> : null;
  return quantityLeft > 0 && quantityLeft < threshold ? (
    <span className={`urgencyMessage--${className}`} style={style}>
      {hyphen}Only <span>{quantityLeft}</span> Left!
    </span>
  ) : quantityLeft <= 0 ? (
    <span className={`urgencyMessage--${className}`} style={style}>
      {hyphen}Sold Out Online
    </span>
  ) : null;
};
